import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import {DARK_TEXT_COLOR, GREEN_BUTTON} from '../../../theme';

// Co-located styles for this component
const styles = {
  label: {
    color: DARK_TEXT_COLOR,
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '140%',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: GREEN_BUTTON,
      },
      '&:hover fieldset': {
        borderColor: GREEN_BUTTON,
      },
      borderRadius: '0.5rem',
      height: '2.5rem',
    },
  },
};

export const DocumentNameField = ({
  documentName,
  error,
  helperText,
  onDocumentNameChange,
}) => {
  return (
    <Stack direction="column" spacing="0.5rem">
      <Typography style={styles.label}>Report name *</Typography>
      <TextField
        error={error}
        helperText={helperText}
        id="createDocument-documentName"
        onChange={onDocumentNameChange}
        sx={styles.textField}
        value={documentName}
        variant="outlined"
      />
    </Stack>
  );
};

DocumentNameField.propTypes = {
  documentName: PropTypes.string.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  onDocumentNameChange: PropTypes.func.isRequired,
};
